import { authValidation } from "../authService";

const DEV_AUTO_LOGIN_EMAILS = [
  "alannguyen.cs@gmail.com",
  "alannguyen@tadreamk.com",
  "thanhnguyenhuu.cs@gmail.com",
  "alanshareteam@gmail.com",
];

/**
 * Check if dev auto-login should bypass password validation
 */
const isDevAutoLogin = (email) => {
  return (
    window.location.hostname === "localhost" &&
    DEV_AUTO_LOGIN_EMAILS.includes(email.trim().toLowerCase())
  );
};

/**
 * Validate sign in form
 */
export const validateSignInForm = (formData, t) => {
  const errors = {};

  // Email validation
  if (!formData.email.trim()) {
    errors.email = t("validation.emailRequired");
  } else if (!authValidation.isValidEmail(formData.email)) {
    errors.email = t("validation.emailInvalid");
  }

  // Password validation - skip for dev auto-login
  if (!isDevAutoLogin(formData.email)) {
    if (!formData.password) {
      errors.password = t("validation.passwordRequired");
    } else if (formData.password.length < 8) {
      errors.password = t("validation.passwordMinLength");
    }
  }

  return { errors, isValid: Object.keys(errors).length === 0 };
};
